import React from 'react'
import {
    Section,
    Container,
} from "./components/index";
import MicroFrontend from '../../../../../helpers/MicroFrontend';
import { ReactComponent as email } from "../../../../../assets/svg/formIcons/Mail.svg";
import { ReactComponent as username } from "../../../../../assets/svg/formIcons/Name.svg";
import { ReactComponent as singleline } from "../../../../../assets/svg/formIcons/SingleLine.svg";
import { ReactComponent as multiline } from "../../../../../assets/svg/formIcons/MultiLine.svg";
import { ReactComponent as number } from "../../../../../assets/svg/formIcons/Number.svg";
import { ReactComponent as section } from "../../../../../assets/svg/formIcons/MultiLine.svg";
import { ReactComponent as label } from "../../../../../assets/svg/formIcons/Label.svg";
import { ReactComponent as select } from "../../../../../assets/svg/formIcons/Select.svg";
import { ReactComponent as checkList } from "../../../../../assets/svg/formIcons/Checklist.svg";
import { ReactComponent as datePicker } from "../../../../../assets/svg/formIcons/DatePicker.svg";
import { ReactComponent as checkbox } from "../../../../../assets/svg/formIcons/CheckBox.svg";
import { ReactComponent as radio } from "../../../../../assets/svg/formIcons/RadioButton.svg";
import { ReactComponent as otp } from "../../../../../assets/images/form_icons/basicFormIcons/otp_ico.svg";
import { ReactComponent as scanner } from "../../../../../assets/images/form_icons/SpecialFormIcons/scannerIcons.svg";
import { ReactComponent as container } from "../../../../../assets/svg/formIcons/container.svg";
import { ReactComponent as table } from "../../../../../assets/svg/formIcons/table.svg";
import { ReactComponent as stat } from "../../../../../assets/svg/statistic_ico.svg";
import { ReactComponent as image } from "../../../../../assets/svg/formIcons/imageIcon.svg";
import { ReactComponent as inputgroup } from "../../../../../assets/svg/formIcons/InputGroup_ico.svg";
import { ReactComponent as emailverif } from "../../../../../assets/svg/formIcons/emailVerfication_ico.svg";
import { ReactComponent as slider } from "../../../../../assets/svg/formIcons/slider.svg";

import { ReactComponent as documentCollector } from "../../../../../assets/images/form_icons/SpecialFormIcons/documentCollector.svg";
import { ReactComponent as markdown } from "../../../../../assets/images/form_icons/markdown.svg";
import { ReactComponent as chatIcon } from "../../../../../assets/images/form_icons/chatIcon.svg";


import { ReactComponent as uploader } from "../../../../../assets/images/form_icons/advancedFormIcons/FileUploader_Icon.svg";
import { ReactComponent as button } from "../../../../../assets/svg/formIcons/Button.svg";
import { ReactComponent as signaturePad } from "../../../../../assets/images/signaturePad.svg";

import { Icon } from "antd";

export const getComponent = (name: string): React.ElementType => {
    switch (name) {
        case "Section":
            return Section;
        case "Container":
            return Container;
        default:
            return MicroFrontend;
    }
};

export const components: any = {
    basic: [
        {
            id: "container",
            json: {
                type: "Container",
                size: "col-md-12",
                style: {},
                core: true,
                properties: {
                    category: "container",
                    layout: {
                        direction: "row",
                    },
                },
                fields: [],
            },
            label: "Container",
            icon: container,
        },
        {
            id: "email",
            json: {
                type: "Input",
                size: "col-md-12",
                style: {},
                core: true,
                properties: {
                    category: "email",
                    label: "Email",
                    placeholder: "Email",
                },
            },
            label: "Email",
            icon: email,
        },
        {
            id: "emailVerifier",
            label: "Email Verification",
            icon: emailverif,
            json: {
                type: "EmailVerification",
                size: "col-md-12",
                style: {},
                core: true,
                properties: {
                }
            },
        },
        {
            label: "Text",
            id: "text",
            icon: username,
            json: {
                type: "Input",
                size: "col-md-12",
                style: {},
                core: true,
                properties: {
                    category: "text",
                    label: "Text",
                    placeholder: "Text",
                },
            },
        },
        {
            id: "inputGroup",
            label: "Input Group",
            icon: inputgroup,
            json: {
                type: "InputGroup",
                size: "col-md-12",
                style: {},
                core: true,
                properties: {
                    label: "Group",
                    placeholder: "Enter a value",
                    buttonText: "Button",
                }
            },
        },
        {
            label: "Single Line",
            id: "name",
            icon: singleline,
            json: {
                type: "Input",
                size: "col-md-12",
                style: {},
                core: true,
                properties: {
                    category: "text",
                    label: "Single Line",
                    placeholder: "Singleline comment",
                },
            },
        },
        {
            label: "Multi Line",
            id: "name",
            icon: multiline,
            json: {
                type: "Input",
                size: "col-md-12",
                style: {},
                core: true,
                properties: {
                    category: "textarea",
                    label: "Multi Line",
                    placeholder: "Multiline comment",
                },
            },
        },
        {
            label: "Number",
            id: "name",
            icon: number,
            json: {
                type: "Input",
                size: "col-md-12",
                style: {},
                core: true,
                properties: {
                    category: "number",
                    placeholder: "Number",
                    label: "Number",
                },
            },
        },
        {
            id: "label",
            label: "Label",
            icon: label,
            json: {
                type: "Label",
                size: "col-md-12",
                style: {},
                core: true,
                properties: {
                    label: "Label"
                }
            },
        },
        {
            id: "button",
            json: {
                type: "Button",
                size: "col-md-4",
                style: {},
                core: true,
                properties: {
                    buttonType: "primary",
                    buttonSize: "default",
                    label: "Button",
                },
            },
            label: "Button",
            icon: button,
        },
        {
            id: "dropdown",
            label: "Select",
            icon: select,
            json: {
                type: "Select",
                size: "col-md-12",
                style: {},
                core: true,
                properties: {
                    label: "Selection",
                    placeholder: "Select",
                },
                data: {}
            },
        },
        {
            id: "chainedDropdown",
            label: "Chained Select",
            icon: select,
            json: {
                type: "ChainedSelect",
                size: "col-md-12",
                style: {},
                core: true,
                properties: {
                    label: "Selection",
                    placeholder: "Select",
                },
                data: {}
            },
        },
        {
            id: "slider",
            label: "Slider",
            icon: slider,
            json: {
                type: "Slider",
                size: "col-md-12",
                style: {},
                core: true,
                properties: {},
                data: {},
            },
        },
        {
            id: "datePicker",
            json: {
                type: "DatePicker",
                size: "col-md-4",
                style: {},
                core: true,
                properties: {
                    showDate: true,
                    FromType: "none",
                    ToType: "none",
                    label: "Date Picker",
                },
            },
            label: "Date Picker",
            icon: datePicker,
        },
        {
            id: "checklist",
            json: {
                type: "CheckList",
                size: "col-md-12",
                style: {},
                core: true,
                properties: {},
            },
            label: "Check List",
            icon: checkList,
        },
        {
            id: "checkbox",
            label: "Check Box",
            icon: checkbox,
            json: {
                type: "CheckBox",
                size: "col-md-12",
                style: {},
                core: true,
                data: {},
                properties: {
                    label: "Checkbox"
                }
            },
        },
        {
            id: "radio",
            label: "Radio Button",
            icon: radio,
            json: {
                type: "RadioButton",
                size: "col-md-12",
                style: {},
                core: true,
                data: {},
                properties: {
                    label: "Radiobutton",
                }
            },
        },
        {
            id: "statCounter",
            label: "Stat Counter",
            icon: stat,
            json: {
                type: "StatCounter",
                size: "col-md-12",
                style: {},
                core: true,
                properties: {}
            },
        },
        {
            id: "imageViewer",
            label: "Image",
            icon: image,
            json: {
                type: "ImageViewer",
                size: "col-md-12",
                style: {},
                core: true,
                data: {
                    async: false
                },
                properties: {
                    fillImage: false
                }
            },
        },
        {
            id: "divider",
            label: "Divider",
            icon: singleline,
            json: {
                type: "Divider",
                size: "col-md-12",
                style: {},
                core: true,
                properties: {},
                data: {},
            },
        },
    ],
    advanced: [
        {
            id: "uploader",
            label: "Uploader",
            icon: uploader,
            json: {
                type: "Uploader",
                size: "col-md-12",
                style: {},
                core: true,
                data: {
                    uploadLimit: 1,
                },
                properties: {
                    label: "Uploader",
                    layoutPosition: "outer",
                    textPosition: "bottomLeft",
                    textColor: "#FA7412",
                    backgroundColor: "#0466C8",
                    date: true,
                    geoCoordinates: true,
                    waterMarkVariables: []
                }
            },
        },
        {
            id: "table",
            json: {
                type: "Table",
                size: "col-md-12",
                style: {},
                properties: {},
                core: true,
                data: {
                    mode: "async",
                }
            },
            label: "Table",
            icon: table,
        },
        {
            id: "section",
            label: "Section",
            icon: section,
            json: {
                type: "Section",
                size: "col-md-12",
                style: {},
                properties: {
                    collapsable: true,
                    defaultCollapse: true
                },
                fields: [],
            },
        },
    ],
    special: [
        {
            id: "scanner",
            label: "Scanner",
            icon: scanner,
            json: {
                type: "Scanner",
                size: "col-md-12",
                style: {},
                data: {},
                core: true,
                properties: {
                    parse: false,
                    label: "Scanner",
                    layoutPosition: "outer",
                    textPosition: "bottomLeft",
                    textColor: "#FA7412",
                    backgroundColor: "#0466C8",
                    date: true,
                    geoCoordinates: true,
                    waterMarkVariables: []
                }
            },
        },

        {
            id: "otp",
            label: "Otp",
            icon: otp,
            json: {
                type: "Otp",
                size: "col-md-12",
                core: true,
                style: {},
                data: {
                    numInputs: 4,
                },
                properties: {
                    label: "Otp"
                }
            },
        },
        {
            id: "documentCollector",
            label: "Document Collector",
            icon: documentCollector,
            json: {
                type: "DocumentCollector",
                size: "col-md-12",
                core: true,
                style: {},
                data: {},
                properties: {}
            },
        },
        {
            id: "SignaturePad",
            label: "Signature Pad",
            icon: signaturePad,
            json: {
                type: "SignaturePad",
                size: "col-md-12",
                core: true,
                style: {},
                data: {},
                properties: {
                    label: "Signature Pad"
                }
            },
        },
        {
            id: 'pdfViewer',
            label: 'Pdf Viewer',
            icon: () => <Icon type="file-pdf" style={{ fontSize: "18px" }} />,
            json: {
                type: "PdfViewer",
                size: "col-md-12",
                style: {},
                core: true,
                data: {
                },
                properties: {
                }
            },
        },
        {
            id: 'MarkDown',
            label: 'Markdown',
            icon: markdown,
            json: {
                type: "Markdown",
                size: "col-md-12",
                style: {},
                core: true,
                data: {
                },
                properties: {
                }
            },
        }
    ],
    GeneratingAI: [
        {
            id: 'QandA',
            label: 'QandA',
            icon: chatIcon,
            json: {
                type: "QandA",
                size: "col-md-12",
                style: {},
                core: true,
                data: {
                },
                properties: {
                }
            },
        }
    ]
};
